import { Box, styled } from "@mui/material";

export const ContentWrapper = styled(Box)(({ theme }) => ({
  maxWidth: "36.4rem",
  padding: theme.spacing(3.2, 1),
  margin: theme.spacing(0, "auto"),
  minHeight: "100%",
}));
